<template>
  <el-dialog :title="type==='add'?'新增导航':'编辑导航'" width="800px" :visible.sync="dialogFormVisible" :before-close="closeCategoryDialog">
    <el-form :model="form" ref="ruleForm" :rules="rules" label-position="right" label-width="120px">
      <el-form-item v-if="form.fullName" label="父级:">
        <div>{{ form.fullName }}</div>
      </el-form-item>
      <el-form-item label="导航名称:" prop="name">
        <el-input type="text" placeholder="请输入导航名称" v-model="form.name" style="width:300px" />
      </el-form-item>
      <el-form-item label="导航图片:" prop="imgUrl">
        <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'imgUrl')">
          <div v-if="form.imgUrl" class="img f-c-c">
            <img :src="form.imgUrl" style="height:70px">
          </div>
          <div v-else class="f-c-c fd-c" style="width:250px;height:100%;">
            <i class="el-icon-plus avatar-uploader-icon" />
            <p>建议尺寸: 440 x 80</p>
          </div>
          <div class="delete" v-if="form.imgUrl" @click.stop="imgDelete('imgUrl')">
            删除
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="推荐标识:" prop="labelImgUrl">
        <el-upload ref="beforeUpload" class="upload-img" action="#" :show-file-list="false" :before-upload="(file) => beforeUpload(file, 'labelImgUrl')">
          <div v-if="form.labelImgUrl" class="img f-c-c">
            <img :src="form.labelImgUrl" style="height:70px">
          </div>
          <div v-else class="f-c-c fd-c" style="height:100%;width:120px;">
            <i class="el-icon-plus avatar-uploader-icon" />
            <p>建议尺寸: 32x56</p>
          </div>
          <div class="delete" v-if="form.labelImgUrl" @click.stop="imgDelete('labelImgUrl')">
            删除
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="菜单类型:" prop="menuType">
        <el-select v-model="form.menuType" placeholder="请选择" @change="changeType">
          <el-option
            v-for="item in menuType"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.menuType === 4" label="菜单链接:" prop="linkUrl">
        <el-input v-model="form.linkUrl" style="width: 500px" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item v-if="form.menuType && form.menuType!==4" label="菜单链接:" prop="linkId">
        <el-cascader
          v-if="form.menuType === 3"
          v-model="form.linkId"
          :options="categoryOptions"
          :props="{ value: 'categoryId', label: 'name', children: 'childList', checkStrictly: true, emitPath: false, expandTrigger: 'hover' }"
          @change="selectCategory"></el-cascader>
        <el-select v-else v-model="form.linkId" placeholder="请选择" style="width: 300px" @change="changeTypeItem">
          <el-option
            v-for="item in typeItem"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeCategoryDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialogVisible">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from "@/api";
import { flatTree } from '@/utils/tree.js'
// import _ from 'lodash'

const rules = {
  name: [{ required: true, message: '请输入导航名称', trigger: 'blur' }],
  menuType: [{ required: true, message: '请选择菜单类型', trigger: 'change' }],
  linkId: [{ required: true, message: '请选择菜单链接', trigger: 'change' }],
  linkUrl: [{ required: true, message: '请输入菜单链接', trigger: 'blur' }],
}

const menuType = [
  { code: 0, name: '无' },
  { code: 1, name: '专辑' },
  { code: 2, name: '活动' },
  { code: 3, name: '品类' },
  { code: 4, name: '自定义URL' },
]

export default {
  data() {
    return {
      dialogFormVisible: false,
      rules: rules,
      type: undefined, // 弹窗类型
      form: {},
      menuType, // 菜单枚举
      typeItem: [], // 菜单枚举对应的活动id
      categoryOptions: [] // 品类树
    }
  },
  created() {
    this.getCustomNavMenuType()
  },
  methods: {
    // 显示弹框
    show(type, row) {
      this.type = type
      this.dialogFormVisible = true
      if (type === 'add') {
        this.form.level = (row && row.level+1) || 1
        this.form.parentId = (row && row.menuId) || undefined
      } else {
        this.form.id = row.id
        this.changeType(row.menuType)
        this.$set(this.form, 'fullName', row.fullName)
        this.$set(this.form, 'name', row.name)
        this.$set(this.form, 'imgUrl', row.imgUrl)
        this.$set(this.form, 'labelImgUrl', row.labelImgUrl)
        this.$set(this.form, 'menuType', row.menuType)
        this.$set(this.form, 'linkId', row.linkId)
        this.$set(this.form, 'linkName', row.linkName)
        this.$set(this.form, 'linkUrl', row.linkUrl)
      }
    },
    // 关闭弹框
    closeCategoryDialog() {
      this.form = {}
      this.dialogFormVisible = false
      this.$refs.ruleForm.resetFields()
    },
    // 弹框确认
    confirmDialogVisible() {
      let apiParam = this.type === 'add' ? 'addCustomNav' : 'editCustomNav'
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        API[apiParam](this.form).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.closeCategoryDialog()
          this.$message.success(this.type === 'add' ? '新增成功' : '编辑成功')
          this.$emit('addSuccess')
        })
      })
    },
    // 上传
    beforeUpload(file, type) {
      API.signValue({ directory: 'customNav/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'customNav/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.$set(this.form, type, result.data)
        })
      })
      return false
    },

    // 菜单类型枚举
    getCustomNavMenuType() {
      API.getCustomNavMenuType().then(res => {
        this.menuType = res.data
      })
    },

    // 获取品类树
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    // 删除最后一级为空的childList字段
    deletechildList(arr) {
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },

    // 选择菜单类型
    changeType(e) {
      this.$set(this.form, 'linkId', '')
      this.$set(this.form, 'linkName', '')
      this.$set(this.form, 'linkUrl', '')

      if ([1, 2].includes(e)) API.getCustomNavDropValue(e).then(res => {
        this.typeItem = res.data
      })
      if (e === 3) this.getCategoryList()
    },

    // 选择活动，专辑id
    changeTypeItem(e) {
      this.typeItem.forEach(item => {
        if (e === item.id) {
          this.$set(this.form, 'linkName', item.name)
          // this.$set(this.form, 'linkUrl',this.form.menuType === 1 ? `/mall/album?moduleId=${item.id}`
          this.$set(this.form, 'linkUrl',this.form.menuType === 1 ? `/album/${item.moduleUrl}`
           : `${item.reserve=='1'?'/mall/flash-sale?discountId=':item.reserve=='2'?'/mall/discount?discountId=':'/mall/festival-collection?discountId='}${item.id}`)
        }
      })
    },

    // 选择品类id
    selectCategory(value) {
      let TiledArr = flatTree(this.categoryOptions, item => ({ id: item.categoryId, name: item.name, categoryUrl: item.categoryUrl  }), 'childList')
      TiledArr.forEach(item => {
        if (item.id === value) {
          this.$set(this.form, 'linkName', item.name)
          this.$set(this.form, 'linkUrl', `/product-list/${item.categoryUrl}`)
        }
      })
    },
    
    imgDelete(type) {
      this.$set(this.form, type, '')
    },
  }
}
</script>

<style  lang="scss" scoped>

.upload-img{
  height: 70px;
  font-size: 14px;
  /deep/ .el-upload {
    border: 1px dotted #999 !important;
    height: 100%;
    position: relative;
    .delete {
      position: absolute;
      right: -50px;
      bottom: 0;
      height: 30px;
    }
  }
  .avatar-uploader-icon {
    font-size: 24px;
    font-weight: 600;
  }
  img {
    height: 16 0px;
    object-fit: cover;
  }
  p {
    line-height: 30px;
  }
}
</style>